import { queryKeys } from '../../queryKeys';
import { useQuery } from '../base';

/**
 * Billing pregled organizacije (`{ plan, subscription, discount }`).
 * `enabled` postoji zbog uslovnog rendera (F2.4: globalni baner sme da pita
 * samo uz org kontekst + `billing_read` permisiju).
 */
export function useOrgBillingOverview({
  enabled = true,
  organizationId,
}: {
  organizationId: string;
  enabled?: boolean;
}) {
  const { queryFn, queryKey } =
    queryKeys.platformBilling.fetchOrgBillingOverview({ organizationId });
  return useQuery({
    enabled: enabled && !!organizationId,
    queryFn,
    queryKey,
  });
}
